import React from 'react'
import { ErrorOutlineIcon } from '../../../../ui/icon'
import IconTextView from '../icon-text-view'

export interface ErrorViewProps {
    message: string
}

export default function ErrorView({ message }: ErrorViewProps) {
    return (
        <IconTextView
            icon={<ErrorOutlineIcon />}
            text={message}
        />
    )
}